import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTabSwiper from 'eco-design/sections/eco-tab-swiper';
import styles from './index.module.scss';

export default function SectionA1() {
    const { t } = useLang('delta_pro_ultra.launch.detail.SectionA6');

    const items = [
        {
            tabValue: 'A1',
            tabLabel: t('tab_label1'),
            bottomContent: t('tab_content1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750404950876/pc_Home%20Power.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750404951249/m_Home%20Power.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', list_name: t('title') || 'none', button_name: t('tab_label1') },
        },
        {
            tabValue: 'A2',
            tabLabel: t('tab_label2'),
            bottomContent: t('tab_content2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750404951623/pc_Solar%20Storage.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750404951449/m_Solar%20Storage.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', list_name: t('title') || 'none', button_name: t('tab_label2') },
        },
        {
            tabValue: 'A3',
            tabLabel: t('tab_label3'),
            bottomContent: t('tab_content3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750404950468/pc_Backup.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750405098500/m_Backup.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', list_name: t('title') || 'none', button_name: t('tab_label3') },
        },
        {
            tabValue: 'A4',
            tabLabel: t('tab_label4'),
            bottomContent: t('tab_content4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750404951054/pc_Industry%20%26%20Commercial.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750404950654/m_Industry%20%26%20Commercial.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', list_name: t('title') || 'none', button_name: t('tab_label4') },
        },
    ];

    return (
        <div className={`page-sectionA6 ${styles.SectionA6}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.SectionA6}`}>
                <EcoTabSwiper theme="black" items={items} />
                <div className="note">{t('tip')}</div>
            </div>
        </div>
    );
}
